export interface IWorkflow {
    emailAddress: string,
    confirmationCode: string,
    password: string,
    confirmPassword: string
}
